import * as React from "react";
import type { SVGProps } from "react";
const SvgChartModernSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <rect
      width={18}
      height={18}
      x={3}
      y={3}
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      rx={5}
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.868 11.658 7.5 14.5M13.184 13.48l-3.316-1.822M16.5 9.5l-3.316 3.979"
    />
  </svg>
);
export default SvgChartModernSquare;
